<script setup lang="ts">
  import { ref, watch } from 'vue'

  const props = defineProps<{
    src?: string | null,
    alt?: string,
    srcset?: string,
    sizes?: string,
  }>()

  const error = ref(false)

  watch(
    () => props.src,
    () => {
      error.value = false
    },
  )
</script>

<template>
  <div class="overflow-hidden">
    <div
      v-if="!src || error"
      class="size-full bg-gray-200"></div>
    <img
      v-else
      class="size-full"
      :src="src"
      :srcset="srcset"
      :sizes="sizes"
      :alt="alt"
      @error="error = true">
  </div>
</template>

<style scoped>
@reference "@/assets/styles/main.css";

.object-cover img {
  @apply object-cover;
}
</style>
